import { useCallback } from 'react';

import { LocalStore } from 'constants/localstore';
import { RootState } from 'store/store';
import { useAppStore } from 'store/store-hooks';
import { aggregateData } from 'components/app/editor/_mediator/monitor/monitor-req.slice';
import { BackupTitle } from 'components/app/editor/_mediator/backup/backup.slice';

export interface MonitorRejectionLocalStore {
  err: string;
  actions: BackupTitle[];
}

export const useApi = () => {
  const store = useAppStore();
  const storeApi = useCallback(() => {
    const state = store.getState();
    if (state.monitorReq.rejectData) {
      const { pending, buffer, rejectData } = state.monitorReq;
      const payloads = [...(pending ?? []), ...(buffer ?? [])];
      const actions = payloads.flatMap((item) => item.actions);
      const uniqueActions: BackupTitle[] = Array.from(new Set(actions.flat()));
      const data: MonitorRejectionLocalStore = { err: rejectData, actions: uniqueActions };
      localStorage.setItem(LocalStore.monitorRejection, JSON.stringify(data));
      return;
    }
    const payloads = getPayloads(selectData(state));
    if (payloads.length) localStorage.setItem(LocalStore.payloads, JSON.stringify(payloads));
  }, []);
  return { storeApi };
};

/* S E L E C T O R */

type Data = ReturnType<typeof selectData>;

const selectData = (state: RootState) => {
  const { markers, storyBoard, clipsMap, selectedMarkerPreset, storyConfig } = state.editor;
  const { pending, buffer } = state.monitorReq;
  const { clipThumbnails } = state.clipThumb;
  const { selectedStory: storyId } = state.projects;
  const fileConfigs = state.app__files.configs;
  const log = state.app__logger.recentActions;
  const monitor = state.monitor;
  return {
    storyBoard,
    markers,
    pending,
    buffer,
    log,
    storyId,
    monitor,
    clipsMap,
    fileConfigs,
    storyConfig,
    clipThumbnails,
    selectedMarkerPreset,
  };
};

/* H E L P E R */

const getPayloads = (data: Data) => {
  const {
    storyBoard,
    clipsMap,
    markers,
    pending,
    buffer,
    log,
    storyId,
    monitor,
    fileConfigs,
    storyConfig,
    clipThumbnails,
    selectedMarkerPreset,
  } = data;
  const payloads = [...(pending ?? []), ...(buffer ?? [])];
  if (monitor.isDirty && storyId) {
    payloads.push(
      aggregateData({
        monitor,
        storyId,
        clipsMap,
        storyBoard,
        clipThumbnails,
        log,
        markers,
        fileConfigs,
        storyConfig,
        selectedMarkerPreset,
      })
    );
  }
  return payloads;
};
